export enum Region {
  US = 'us',
  EU = 'eu',
  AU = 'au',
  // UAE = 'uae',
}

export interface AuthContext {
  orgId: string;
  userId: string;
  region: Region;
  isDemoUser?: boolean;
}